import React from "react";


import my_Image from "../images/my_Image.jpg";  // Correct import with file extension

export default function About() {
  return (
    <section id="about">
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Hi, I'm Srushti
            <br className="hidden lg:inline-block" />Welcome to my Portfolio!
          </h1>
          <p className="mb-8 leading-relaxed">
          Hi👋🏻 I'm Srushti, a Salesforce Enthusiast. As an IT Engineering graduate, I bring a solid foundation in technical skills and a keen interest in applying them to real-world challenges. I'm skilled in C++, JavaScript, React, Spring-MVC. I am passionate about leveraging my knowledge to drive innovation and efficiency. I am currently seeking new opportunities to contribute to a forward-thinking team and continue growing in the tech industry.
          </p>
          <div className="flex justify-center">
            <a
              href="#contact"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
              Work With Me
            </a>
            <a
              href="https://github.com/Srushtik942"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
              See My Past Work
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-cover object-center rounded-3xl w-52 my-4"
            alt="hero"
            src={my_Image}/>
        </div>
      </div>
    </section>
  );
}